import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import _ from 'lodash';
import TravelerIcon from './TravelerIcon';

const Travelers = ({ travelers, bookingId }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const formatTravelers = (travelers) => {
		if (!_.isArray(travelers) || travelers.length === 0) return '';

		const travelersCount = travelers.length;
		const [firstTraveler, secondTraveler] = travelers;

		if (travelersCount === 1) return firstTraveler.full_name;
		if (travelersCount === 2) return `${firstTraveler.full_name}, ${secondTraveler.full_name}`;

		const otherTravelersCount = travelersCount - 2;
		const otherTravelersText =
			otherTravelersCount === 1 ? t('andOneOtherGuest') : t('andOtherGuests', { count: otherTravelersCount });

		return `${firstTraveler.full_name}, ${secondTraveler.full_name} ${otherTravelersText}`;
	};

	const handleClick = () => {
		navigate('/bookings', { state: { id: bookingId }, replace: true });
	};

	return (
		<div className="travelers">
			<div className="travelers__title">
				<TravelerIcon />
				<div className="travelers__title-text">{t('Travelers')}:</div>
			</div>
			<div className="travelers__names">{formatTravelers(travelers)}</div>
			<div className="go-to-booking-page" onClick={handleClick}>
				{t('GoToBookingsPage')}
			</div>
		</div>
	);
};

export default Travelers;
